'use client';

import { ThemeProvider } from '@mui/material/styles';
import { SWRConfig } from 'swr';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@/lib/theme';
import MuiXLicense from './MuiXLicense';
import { AuthenticationProvider } from './AuthenticationProvider';
import { IntlProvider } from './IntlProvider';
import { ShellContextProvider } from './ShellContext';
import { SnackbarProvider } from './SnackbarProvider';
import { DatadogProvider } from '@/components/DatadogProvider/DatadogProvider';
import { LaunchDarklyProvider } from './LaunchDarklyProvider';
import HeartBeatProvider from './HeartBeat';

export interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <LaunchDarklyProvider>
      <DatadogProvider>
        <MuiXLicense />
        <SWRConfig
          value={{
            revalidateIfStale: false,
            revalidateOnFocus: false,
          }}
        >
          <HeartBeatProvider>
            <ThemeProvider theme={theme} defaultMode="system">
              <CssBaseline />
              {/* `LocalizationProvider` lives in `DateLocalizationProvider`
                  and is mounted from layouts/components that actually render
                  date pickers. Keeping it out of the always-mounted tree shaves
                  `@mui/x-date-pickers` + the `date-fns` adapter graph
                  (~170 KB gzip) off routes without date fields. */}
              {/* `ConfirmProvider` (material-ui-confirm) is scoped to the
                  private layouts that need it, so public routes like /search
                  do not ship the Dialog + Backdrop subtree. */}
              <AuthenticationProvider>
                <IntlProvider>
                  <SnackbarProvider>
                    <ShellContextProvider>{children}</ShellContextProvider>
                  </SnackbarProvider>
                </IntlProvider>
              </AuthenticationProvider>
            </ThemeProvider>
          </HeartBeatProvider>
        </SWRConfig>
      </DatadogProvider>
    </LaunchDarklyProvider>
  );
};
